import React from 'react';
import Nav from '../components/app/Nav';
import SEO from '../components/app/SEO';
import Footer from '../components/app/Footer';
import styles from '../styles/app/AboutUsPage.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHistory,
  faStar,
  faUsers,
  faBuilding,
  faCheckCircle,
  faClock,
  faShieldAlt,
  faTag,
  faHeadset,
  faBoxOpen
} from '@fortawesome/free-solid-svg-icons';
import teamImg from '../assets/app/team.png';

const AboutUsPage: React.FC = () => {
  return (
    <div className="bg-light min-vh-100">
      <SEO
        title="Nuestra Empresa y Equipo | elPaket"
        description="Conoce la historia, visión y el equipo detrás de elPaket, conectando a la comunidad latina en USA con sus seres queridos y negocios en Latinoamérica."
        canonicalUrl="https://elpaket.com/about-us"
      />
      <Nav />

      <main className={styles.aboutContainer}>
        <div className={styles.heroContent}>
          <h1>Quiénes Somos</h1>
          <p className="lead text-muted">Conectando familias y negocios entre USA y Latinoamérica.</p>
        </div>

        {/* Nuestra Historia */}
        <section className={`${styles.aboutSection} fade-in`}>
          <h2>
            <FontAwesomeIcon icon={faHistory} /> Nuestra Historia
          </h2>
          <div className={styles.historyText}>
            <p>
              <b>elPaket</b> fue fundada con una misión clara:
              facilitar envíos rápidos, seguros y económicos entre USA
              y Venezuela mediante tecnología UPS de última generación.
            </p>
            <p>
              Lo que comenzó como un pequeño proyecto para ayudar a amigos y familiares,
              se ha convertido en una plataforma logística de confianza para miles de clientes
              que buscan eficiencia y seguridad en sus envíos internacionales.
            </p>
          </div>
        </section>

        {/* Qué nos hace diferentes */}
        <section className={`${styles.aboutSection} fade-in`} style={{ animationDelay: '0.1s' }}>
          <h2>
            <FontAwesomeIcon icon={faStar} /> Qué nos hace diferentes
          </h2>
          <div className={styles.featuresGrid}>
            <div className={styles.featureCard}>
              <FontAwesomeIcon icon={faCheckCircle} className="text-primary mb-3" size="2x" />
              <b>Automatización Total</b>
              <span>Sistema de etiquetas UPS 100% automatizado para tu comodidad.</span>
            </div>
            <div className={styles.featureCard}>
              <FontAwesomeIcon icon={faClock} className="text-primary mb-3" size="2x" />
              <b>Rapidez Garantizada</b>
              <span>Entrega promedio de 5 a 7 días hábiles en tus envíos aéreos.</span>
            </div>
            <div className={styles.featureCard}>
              <FontAwesomeIcon icon={faShieldAlt} className="text-primary mb-3" size="2x" />
              <b>Tracking Real</b>
              <span>Monitoreo en tiempo real desde que sale el paquete hasta su destino.</span>
            </div>
            <div className={styles.featureCard}>
              <FontAwesomeIcon icon={faTag} className="text-primary mb-3" size="2x" />
              <b>Precios Honestos</b>
              <span>Tarifas competitivas sin sorpresas ni cargos ocultos al final.</span>
            </div>
            <div className={styles.featureCard}>
              <FontAwesomeIcon icon={faHeadset} className="text-primary mb-3" size="2x" />
              <b>Soporte Dedicado</b>
              <span>Atención al cliente personalizada para resolver todas tus dudas.</span>
            </div>
            <div className={styles.featureCard}>
              <FontAwesomeIcon icon={faBoxOpen} className="text-primary mb-3" size="2x" />
              <b>Casillero Gratuito</b>
              <span>Regístrate gratis y obtén tu propia dirección en Miami para tus compras.</span>
            </div>
          </div>
        </section>

        {/* Nuestro Equipo */}
        <section className={`${styles.aboutSection} fade-in`} style={{ animationDelay: '0.2s' }}>
          <h2>
            <FontAwesomeIcon icon={faUsers} /> Nuestro Equipo
          </h2>
          <div className={styles.teamContent}>
            <div className={styles.teamImage}>
              {/* In a real scenario, use generate_image if no image is available */}
              <div style={{ height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '20px' }}>
                <img src={teamImg}></img>
              </div>
            </div>
            <div className={styles.teamText}>
              <p>
                Somos un equipo de venezolanos apasionados por la logística y el servicio.
                Entendemos de primera mano la necesidad de conectar familias y negocios
                de manera confiable en todo el territorio nacional.
              </p>
              <p>
                Trabajamos cada día para optimizar nuestros procesos y asegurarnos
                de que cada caja enviada llegue a su destino con el cuidado y la rapidez
                que nuestros clientes merecen.
              </p>
            </div>
          </div>
        </section>

        {/* Información Legal */}
        <section className={`${styles.aboutSection} fade-in`} style={{ animationDelay: '0.3s' }}>
          <h2>
            <FontAwesomeIcon icon={faBuilding} /> Información Legal
          </h2>
          <div className={styles.legalList}>
            <div className={styles.legalItem}>
              <span className={styles.legalLabel}>Nombre Legal</span>
              <span className={styles.legalValue}>Tus Envíos LLC</span>
            </div>
            <div className={styles.legalItem}>
              <span className={styles.legalLabel}>Registro</span>
              <span className={styles.legalValue}>L123456789 - Florida</span>
            </div>
            <div className={styles.legalItem}>
              <span className={styles.legalLabel}>Dirección</span>
              <span className={styles.legalValue}>Miami, FL, USA</span>
            </div>
            <div className={styles.legalItem}>
              <span className={styles.legalLabel}>Fundada</span>
              <span className={styles.legalValue}>2026</span>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AboutUsPage;
